import React, { useEffect } from 'react';
import './HeroSection.css';
import 'particles.js';

function HeroSection() {
    useEffect(() => {
        window.particlesJS.load('particles-js', 'assets/particles.json', function() {
            console.log('callback - particles.js config loaded');
        });
    }, []);

    return (
        <div className="hero">
            <div className="hero-content" id='hero'>
                <div className="content">
                    <div className="text-container">
                        <h1 className="welcome-text-hero">Bienvenido al próximo nivel del marketing</h1>
                        <p className="subtext-hero">Desde el brand hasta tus campañas, somos la opcíon más creativa para tu marca.</p>
                    </div>
                    <div className="button-group">
                        <a id="mainButtonHero" className="main-button" href="#services">Servicios</a>
                        <a id="secondaryButtonHero" className="secondary-button" href="#services" >Portafolio <img src="/icons/right-arrow.svg" alt="Arrow" className="arrow-icon" /></a>
                    </div>
                </div>
                <div className="visual-content">
                    <img src="/hero/sound-wave.png" className="sound-wave"></img>
                    <img src="/hero/yellowthing.png" alt="Yellow Thing" className="yellow-thing" />
                </div>
            </div>
            <div id="particles-js"></div>
        </div>
    );
}

export default HeroSection;
